import { construirHojaTabla, descargarLibro, texto, numero } from "../../../../../Components/ExcelTablaReporte";

const redondear1 = (valor) => Math.round(valor * 10) / 10;

export const agruparPareto = (filas = []) => {
  const porEtapa = new Map();
  filas.forEach((fila) => {
    const clave = String(fila.etapaId);
    if (!porEtapa.has(clave)) {
      porEtapa.set(clave, { etapaId: fila.etapaId, etapa: fila.etapa, flujo: fila.flujo, ordenEtapa: fila.ordenEtapa || 0, motivos: [] });
    }
    porEtapa.get(clave).motivos.push(fila);
  });

  return [...porEtapa.values()]
    .map((grupo) => {
      const total = grupo.motivos.reduce((acc, m) => acc + (m.piezas || 0), 0);
      let acumulado = 0;
      const motivos = [...grupo.motivos]
        .sort((a, b) => {
          if (!a.motivoId !== !b.motivoId) return a.motivoId ? -1 : 1;
          return (b.piezas || 0) - (a.piezas || 0);
        })
        .map((motivo) => {
          acumulado += motivo.piezas || 0;
          return {
            ...motivo,
            porcentaje: total ? redondear1(((motivo.piezas || 0) / total) * 100) : 0,
            porcentajeAcumulado: total ? redondear1((acumulado / total) * 100) : 0,
          };
        });
      const costo = grupo.motivos.reduce((acc, m) => acc + (m.costo || 0), 0);
      return { ...grupo, total, costo, motivos };
    })
    .sort((a, b) => a.flujo.localeCompare(b.flujo) || a.ordenEtapa - b.ordenEtapa);
};

const tablaPareto = (grupos) => {
  const columnas = [
    { titulo: "Flujo", tipo: "texto", ancho: 26 },
    { titulo: "Etapa", tipo: "texto", ancho: 24 },
    { titulo: "Motivo", tipo: "texto", ancho: 36 },
    { titulo: "Piezas", tipo: "numero", ancho: 12 },
    { titulo: "%", tipo: "numero", ancho: 10 },
    { titulo: "% acumulado", tipo: "numero", ancho: 14 },
    { titulo: "Costo", tipo: "numero", ancho: 14 },
    { titulo: "Movimientos", tipo: "numero", ancho: 14 },
  ];
  const filas = grupos.flatMap((grupo) =>
    grupo.motivos.map((motivo) => [
      texto(grupo.flujo),
      texto(grupo.etapa),
      texto(motivo.motivo),
      numero(motivo.piezas),
      numero(motivo.porcentaje),
      numero(motivo.porcentajeAcumulado),
      numero(motivo.costo),
      numero(motivo.movimientos),
    ])
  );
  return { columnas, filas, totales: columnas.map(() => null) };
};

export const descargarReporteMotivosExcel = ({ entradas, empresaNombre, descripcionFiltros, nombreArchivo }) => {
  descargarLibro(
    [
      {
        nombre: "Motivos por etapa",
        hoja: construirHojaTabla(tablaPareto(agruparPareto(entradas)), {
          titulo: "Piezas por motivo de entrada a la etapa",
          empresaNombre,
          descripcionFiltros,
        }),
      },
    ],
    nombreArchivo
  );
};
